import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";
import { Toaster } from "sonner";
import "@/index.css";
import { i18n } from "@/shared/i18n";
import { restoreSession } from "@/features/auth";
import { queryClient } from "./query-client";
import { router } from "./router";
import { hideSplashWhenReady } from "./splash";
import { reloadForNewBuild } from "./staleBuild";

// Restore the session (the httpOnly refresh cookie; inside Telegram first the Mini App launch data) before the first
// protected request. RequireAuth shows a spinner until this settles.
void restoreSession();

// Catalog texts come localized from the backend (Accept-Language): refetch them in the new language.
i18n.on("languageChanged", () => {
  void queryClient.invalidateQueries();
});

// Vite fails to preload a chunk of the previous release (the tab was open during a deploy).
window.addEventListener("vite:preloadError", (event) => {
  if (reloadForNewBuild()) event.preventDefault();
});

const root = document.getElementById("root");
if (!root) throw new Error("#root element is missing in index.html");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <Toaster position="top-center" richColors />
    </QueryClientProvider>
  </StrictMode>,
);

hideSplashWhenReady({
  isRendered: () => router.state.initialized,
  isFetching: () => queryClient.isFetching() > 0,
});
